import ArrowForward from '@mui/icons-material/ArrowForward'
import People from '@mui/icons-material/People'
import Person from '@mui/icons-material/Person'
import {
	IconButton,
	TableCell
} from '@mui/material'
import { runInAction } from 'mobx'
import { observer, useLocalObservable } from 'mobx-react'
import { useEffect, useMemo } from 'react'
import { useHistory } from 'react-router'
import {
	AssignmentType,
	WorkflowTaskPermissions,
	WorkflowTaskQueueSnapshot,
} from '../../../../api/clients/workflowTasks/DTOs'
import WorkflowTaskQueueClient from '../../../../api/clients/workflowTasks/WorkflowTaskQueueClient'
import WorkflowTasksClient from '../../../../api/clients/workflowTasks/WorkflowTasksClient'
import UserChip from '../../../../components/chips/UserChip'
import { FullscreenSpinner } from '../../../../components/feedback/circular'
import { TableColumn } from '../../../../components/tables/DTO'
import { FilteredTable } from '../../../../components/tables/FilteredTable'
import { SessionService } from '../../../../services/session/SessionService'
import AdministrationPageContainer from '../AdministrationPageContainer'
import { updateBreadcrumbs } from '../Breadcrumbs'

export const WorkflowTasksPage = observer(() => {
	const history = useHistory()
	const sessionService = SessionService.getInstance()

	updateBreadcrumbs(`/_administration/tasks`, 'Tasks')

	const workflowTasksClient = new WorkflowTasksClient()
	const workflowTaskQueueClient = new WorkflowTaskQueueClient()

	const localStore = useLocalObservable(() => ({
		queueSnapshots: undefined as WorkflowTaskQueueSnapshot[] | undefined
	}))

	const handleGoToQueue = async (id: number): Promise<void> => {
		const nextId = (await workflowTaskQueueClient.getNextInQueue(id)).data
		await workflowTasksClient.getWorkflowTask(
			nextId,
			WorkflowTaskPermissions.Write,
		) // set up the workflow task with lock password
		history.push(`/_tasks/${nextId}`)
	}

	const addQueues = async () => {
		const userId = sessionService.userId

		const snapshotsResponse = await workflowTaskQueueClient.getQueueSnapshots(
			userId,
		)

		const snapshots = snapshotsResponse.data
		runInAction(() => localStore.queueSnapshots = snapshots)
	}

	useEffect(() => {
		addQueues()
	}, [])

	const columns: TableColumn<WorkflowTaskQueueSnapshot>[] = useMemo(() => [
		{
			renderContent: (q) =>
				q.assignmentType === AssignmentType.Group ? <People />
					: q.assignmentType === AssignmentType.User ? <Person /> : ""
		},
		{
			label: "Assigned To",
			renderContent: (q) =>
				<UserChip
					assignmentType={q.assignmentType}
					id={q.assignedTo}
				/>
		},
		{
			name: "itemCount",
			label: "Number of Items"
		},
		{
			renderHeading: <TableCell key={3} align="right">Actions</TableCell>,
			renderCell: (q) =>
				<TableCell key={3} align="right">
					<IconButton
						onClick={() => handleGoToQueue(q.assignedTo)}
						disabled={q.itemCount < 1}
					>
						<ArrowForward fontSize="small" />
					</IconButton>
				</TableCell>
		}
	], [localStore.queueSnapshots])

	return (
		<AdministrationPageContainer title="Tasks">
			{localStore.queueSnapshots === undefined || localStore.queueSnapshots.length === 0 ? (
				<FullscreenSpinner />
			) : (
				<FilteredTable
					allEntries={localStore.queueSnapshots}
					columns={columns}
				/>
			)}
		</AdministrationPageContainer>
	)
})